var _this = this;
import * as tslib_1 from "tslib";
import onSelectionChange from '../events/onSelectionChange';
import singleSelectRowInternal from '../internal/singleSelectRowInternal';
import * as mailListSelectionActions from 'owa-mail-actions';
import { orchestrator } from 'satcheljs';
/////////////////////////////////////// PLEASE READ ///////////////////////////////////////////////////////////
// This is a top level selection action, as such, it should never call other top-level selection
// actions in the same directory, but only call into internal subdirectories where the core logic is implemented.
// This prevents double logging for CTQs as well as prevents onSelectionChange from being fired multiple times
// for a single user action.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Single select mail row action
 * @param tableView where the operation is being performed
 * @param rowKey the rowKey of the item to select
 * @param isUserNavigation whether user's click or action triggered this action
 * @param mailListItemSelectionSource The source of selection on mail item
 */
export default orchestrator(mailListSelectionActions.singleSelectRow, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var tableView, isUserNavigation, mailListItemSelectionSource;
    return tslib_1.__generator(this, function (_a) {
        tableView = actionMessage.tableView;
        isUserNavigation = actionMessage.isUserNavigation;
        mailListItemSelectionSource = actionMessage.mailListItemSelectionSource;
        singleSelectRowInternal(tableView, actionMessage.rowKey, isUserNavigation, mailListItemSelectionSource);
        // Propagate selection change event
        return [2 /*return*/, onSelectionChange(tableView, isUserNavigation, mailListItemSelectionSource).then(function () {
                mailListSelectionActions.onAfterSelectionChanged(actionMessage.rowKey, tableView, mailListItemSelectionSource, tableView.tableQuery.listViewType);
            })];
    });
}); });
//# sourceMappingURL=singleSelectRowOrchestrator.js.map